import { render, staticRenderFns } from "./UpdateSubfactor.vue?vue&type=template&id=f6ab8ac6&scoped=true&"
import script from "./UpdateSubfactor.vue?vue&type=script&lang=js&"
export * from "./UpdateSubfactor.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSubfactor.vue?vue&type=style&index=0&id=f6ab8ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ab8ac6",
  null
  
)

export default component.exports